//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'TagsDisplay',
  props: {
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    linkable: {
      type: Boolean,
      default: false
    }
  }
}
